var exports = {
  "Q": "x4c3adb35--5af7a9--text",
};

module.exports = exports;
